import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "@fluentui/react-components";
import { BordersAll, BordersHorizontal, BordersVertical, BordersNone, BordersTable } from "../../../assets/icons";
import { makeStyles } from "@fluentui/react-components";
import { add, reset } from "../../../state/bordersSlice";
import { batchGroupBy } from "../../../helpers/batchGroupBy";

const useClasses = makeStyles({
  PanelButton: {
    justifyContent: "left",
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: 400,
    letterSpacing: "0.02em",
  },
});

const TableBordersMenuItem = () => {
  const classes = useClasses();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const structure = useSelector((state) => state.gridd.present.structure);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto auto auto auto auto",
      }}
    >
      <Button
        id="all_horizontal_borders_button"
        icon={<BordersHorizontal />}
        appearance="subtle"
        className={classes.PanelButton}
        onClick={() => {
          batchGroupBy.start();
          for (let i = 0; i <= structure.rows.length; i++) {
            dispatch(add({ rowIndex: i }));
          }
          batchGroupBy.end();
        }}
      >
        {t("menu.table.borders.horizontal")}
      </Button>
      <Button
        id="all_vertical_borders_button"
        icon={<BordersVertical />}
        appearance="subtle"
        className={classes.PanelButton}
        onClick={() => {
          batchGroupBy.start();
          for (let i = 0; i <= structure.columns.length; i++) {
            dispatch(add({ columnIndex: i }));
          }
          batchGroupBy.end();
        }}
      >
        {t("menu.table.borders.vertical")}
      </Button>
      <Button
        id="around_table_borders_button"
        icon={<BordersTable />}
        appearance="subtle"
        className={classes.PanelButton}
        onClick={() => {
          batchGroupBy.start();
          dispatch(add({ columnIndex: 0 }));
          dispatch(add({ columnIndex: structure.columns.length }));
          dispatch(add({ rowIndex: 0 }));
          dispatch(add({ rowIndex: structure.rows.length }));
          batchGroupBy.end();
        }}
      >
        {t("menu.table.borders.table")}
      </Button>
      <Button
        id="grid_borders_button"
        icon={<BordersAll />}
        appearance="subtle"
        className={classes.PanelButton}
        onClick={() => {
          batchGroupBy.start();
          for (let i = 0; i <= structure.columns.length; i++) {
            dispatch(add({ columnIndex: i }));
          }
          for (let i = 0; i <= structure.rows.length; i++) {
            dispatch(add({ rowIndex: i }));
          }
          batchGroupBy.end();
        }}
      >
        {t("menu.table.borders.all")}
      </Button>
      <Button
        id="clear_borders_button"
        icon={<BordersNone />}
        appearance="subtle"
        className={classes.PanelButton}
        onClick={() => {
          dispatch(reset());
        }}
      >
        {t("menu.table.borders.none")}
      </Button>
    </div>
  );
};

export default TableBordersMenuItem;
